/**
 * Utilitários de Autenticação
 * Funções auxiliares para tradução e tratamento de erros do Supabase Auth
 */
import { TFunction } from 'i18next';

/**
 * Traduz mensagens de erro do Supabase Auth para o idioma configurado
 * Detecta padrões conhecidos de erro e retorna mensagem traduzida amigável
 * 
 * @param errorMessage - Mensagem de erro original do Supabase
 * @param t - Função de tradução do i18next
 * @returns Mensagem traduzida ou mensagem original se não houver tradução
 */
export const translateAuthError = (errorMessage: string, t: TFunction): string => {
  const errorLower = errorMessage.toLowerCase();
  
  // Detectar erro de requisitos de senha (Supabase Auth com políticas de senha)
  if (
    errorMessage.includes('Password should be at least') ||
    errorMessage.includes('Password should contain') ||
    errorLower.includes('password') && errorLower.includes('character')
  ) {
    return t('auth:errors.passwordRequirements');
  }
  
  // Detectar credenciais inválidas
  if (
    errorLower.includes('invalid') && errorLower.includes('credentials') ||
    errorLower.includes('wrong password') ||
    errorLower.includes('user not found') ||
    errorLower.includes('invalid login')
  ) {
    return t('auth:errors.invalidCredentials');
  }
  
  // Detectar email não confirmado
  if (
    errorLower.includes('email not confirmed') ||
    errorLower.includes('not confirmed')
  ) {
    return t('auth:errors.emailNotConfirmed');
  }
  
  // Detectar email já cadastrado
  if (
    errorLower.includes('already registered') ||
    errorLower.includes('already exists') ||
    errorLower.includes('duplicate')
  ) {
    return t('auth:errors.emailAlreadyExists');
  }
  
  // Detectar senha fraca (caso não seja o erro detalhado de requisitos)
  if (
    errorLower.includes('weak password') ||
    (errorLower.includes('password') && errorLower.includes('short'))
  ) {
    return t('auth:errors.weakPassword');
  }
  
  // Detectar erro de rede/conexão
  if (
    errorLower.includes('network') ||
    errorLower.includes('connection') ||
    errorLower.includes('fetch')
  ) {
    return t('auth:errors.networkError');
  }
  
  // Fallback: retorna mensagem original
  return errorMessage;
};
